var M = Object.defineProperty;
var q = (s, e, i) => e in s ? M(s, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[e] = i;
var g = (s, e, i) => q(s, typeof e != "symbol" ? e + "" : e, i);
import { F as h } from "../../index-gVtEopq1.js";
import { buildLabelFromName as c } from "../../shared/utils.js";
import { stepParamsFieldLogicLanguageOptionsResolver as j } from "./step-params-field-logic-language-options-resolver.js";
import { g as H } from "../../_commonjsHelpers-B52_cu2H.js";
import { c as O, r as C, s as f } from "../../set-CmOi9Z8k.js";
import { r as E } from "../../_baseConvert-B-C9YFBB.js";
import { g as P } from "../../get-Dyldbgcc.js";
var p, v;
function I() {
  if (v) return p;
  v = 1;
  var s = Object.prototype, e = s.hasOwnProperty;
  function i(r, t) {
    return r != null && e.call(r, t);
  }
  return p = i, p;
}
var m, y;
function x() {
  if (y) return m;
  y = 1;
  var s = I(), e = O();
  function i(r, t) {
    return r != null && e(r, t, s);
  }
  return m = i, m;
}
var F, b;
function N() {
  if (b) return F;
  b = 1;
  var s = C(), e = s("has", x());
  return e.placeholder = E(), F = e, F;
}
var _ = N();
const $ = /* @__PURE__ */ H(_);
class L {
  constructor(e, i = [], r = []) {
    g(this, "cachedFields");
    g(this, "cachedFieldsMap");
    g(this, "typesMap", {
      string: h.String,
      number: h.Float,
      boolean: h.Boolean,
      object: "object",
      integer: h.Integer,
      array: "array"
    });
    this.schema = e, this.excludedFields = i, this.originalPath = r;
  }
  getUpdatedParamsConfigState(e, i, r, t) {
    const a = this.getField(r, i);
    if (!a || !a.originalPath)
      return e;
    const n = this.getParamsConfigPath(a.originalPath);
    if (t) {
      const o = f(n, t, e);
      return a.originalPath.slice(0, -1).reduce((l, d, u) => f(
        [
          ...this.getParamsConfigPath(a.originalPath.slice(0, u + 1)),
          "type"
        ],
        "object",
        l
      ), o);
    }
    return e;
  }
  getParamsConfigPath(e) {
    return e.flatMap(
      (i, r) => r === 0 ? [i] : ["subParams", i]
    );
  }
  getFieldLogicLanguage(e, i) {
    const r = this.getField(i, e.params);
    if (!r || !r.originalPath)
      return "static";
    const t = P(
      this.getParamsConfigPath(r.originalPath),
      e.paramsConfig
    );
    if (t)
      return t.language;
    const a = this.getFieldLogicLanguageOptions(
      e,
      i
    ), n = this.getFieldValue(e.params, i);
    return n !== void 0 && typeof n != "string" && typeof n != "number" && typeof n != "boolean" && a.includes("json-logic") ? "json-logic" : a[0];
  }
  getFieldLogicLanguageOptions(e, i) {
    const r = this.getFields(e.params);
    return j(r, i);
  }
  getFields(e) {
    if (this.cachedFields)
      return this.cachedFields;
    const i = [], r = (t, a) => {
      var u;
      if (!a.type || Array.isArray(a.type) || a.type === "null")
        return;
      const n = a.type, o = a.originalPath ?? [
        ...this.originalPath,
        t
      ], l = ((u = this.schema.required) == null ? void 0 : u.includes(t)) ?? !1;
      if ("enum" in a && Array.isArray(a.enum)) {
        i.push({
          fieldId: t,
          fieldName: t,
          type: "Enum",
          label: c(t),
          values: a.enum,
          valuesLabels: "enumLabels" in a ? a.enumLabels : void 0,
          required: l,
          originalPath: o
        });
        return;
      }
      const d = this.typesMap[n];
      if (d === "object") {
        i.push({
          fieldId: t,
          fieldName: t,
          type: d,
          label: c(t),
          required: l,
          properties: new L(
            a,
            void 0,
            o
          ).getFields(e),
          originalPath: o
        });
        return;
      }
      i.push({
        fieldId: t,
        fieldName: t,
        type: d,
        label: c(t),
        required: l,
        originalPath: o
      });
    };
    return Object.entries(this.schema.properties ?? {}).filter(([t]) => !this.excludedFields.includes(t)).forEach(([t, a]) => {
      var n, o;
      if (typeof a != "boolean") {
        if ("$ref" in a) {
          const l = (n = a.$ref) == null ? void 0 : n.replace("#/definitions/", "");
          if (!l)
            return;
          const d = (o = this.schema.definitions) == null ? void 0 : o[l];
          return !d || typeof d == "boolean" ? void 0 : r(t, d);
        }
        return r(t, a);
      }
    }), this.cachedFields = i, i;
  }
  getFieldsMap(e) {
    if (this.cachedFieldsMap)
      return this.cachedFieldsMap;
    const i = this.getFields(e), r = Object.fromEntries(
      i.map((t) => [t.fieldName, t])
    );
    return this.cachedFieldsMap = r, r;
  }
  getField(e, i) {
    return this.getFieldsMap(i)[e];
  }
  getUpdatedState(e, i, r) {
    const t = this.getField(i, e);
    return !t || !t.originalPath ? e : f(t.originalPath, r, e);
  }
  validate(e) {
    var r;
    const i = [];
    return (r = this.schema.required) == null || r.forEach((t) => {
      const a = this.getField(t, e);
      a && !$(a.originalPath ?? [], e) && i.push({
        type: "missingField",
        fieldName: t
      });
    }), i.length > 0 ? i : !0;
  }
  getFieldValue(e, i) {
    const r = this.getField(i, e);
    if (!(!r || !r.originalPath))
      return P(r.originalPath, e);
  }
  getInitialState() {
    return {};
  }
}
export {
  L as StepParamsObjectSchemaHandler
};
